module.exports = __webpack_public_path__ + "img/no-vest.894dd9a1.jpg";